/**
 * SimRunner, the mount point for the position pipeline.
 *
 * It used to step the boat and write straight into own ship. That's now split
 * across a clean GNSS seam: GnssFeed runs the simulated source and emits NMEA,
 * GnssIngest parses that feed and updates own ship. SimRunner just composes the
 * two, so the rest of the shell mounts one thing as before.
 *
 * To swap in real hardware, register a real PositionSource in the gnss store in
 * place of GnssFeed. GnssIngest is unchanged.
 */
import { GnssFeed } from '@/gnss/GnssFeed';
import { DeviceGnssFeed } from '@/gnss/DeviceGnssFeed';
import { GnssIngest } from '@/gnss/GnssIngest';
import { BackgroundGeolocationRunner } from '@/gnss/BackgroundGeolocationRunner';

export function SimRunner() {
  return (
    <>
      <GnssFeed />
      <DeviceGnssFeed />
      <BackgroundGeolocationRunner />
      <GnssIngest />
    </>
  );
}
